/*
 * @Author: Damon
 * @Date: 2021-01-25 17:57:36
 * @LastEditors: damon
 * @LastEditTime: 2024-06-24 17:34:11
 * @Description: file content
 */
// eslint-disable-next-line import/prefer-default-export
export const lang = {
  form: {
    login: {
      username: '用户名',
      password: '密码',
      rememberMe: '记住我',
      login: '登录',
      logout: '注销',
    },
  },
  common: {
    submit: '提交',
  },
  languageswitching: '语言切换',
  exceptionpage: {
    index: '异常页面',
    fourzeroone: '401页面',
    fourzerofour: '404页面',
  },
  dashboard: '仪表板',
  system: {
    index: '系统管理',
    user: '用户管理',
    role: '角色管理',
  },
  validate: {
    login: {
      accountrequired: '账号必填',
      passwordrequired: '密码必填',
      accountlengthgreaterthanfour: '账号不允许小于4位',
      passwordlengthgreaterthansix: '密码不允许小于6位',
    },
    user: {
      accountrequired: '账号必填',
      passwordrequired: '密码必填',
      accountlengthgreaterthanfour: '账号不允许小于4位',
      passwordlengthgreaterthansix: '密码不允许小于6位',
    },
  },
  table: {
    table: '表格',
    dynamictable: '动态表格',
    dragtable: '拖曳表格',
    inlineedittable: '内联编辑表格',
    complextable: '复杂表格',
  },
  component: {
    components: '组件库',
    backtotop: '返回顶部',
  },
  advisor: {
    manage: '顾问管理',
    list: '顾问列表',
    managerlist: '经理列表',
    edit: '顾问编辑',
    detail: '顾问详情',
    socialsecuritylist: '社保信息',
    managerdetail: '经理详情',
    import: '顾问星级导入',
    salesUserStatusChangeLog: '账号变更日志',
    salesUserTitleChangesLog: '职位变更日志',
    salesUserInfoChangesLog: '信息变更日志',
    salesUserGroupChangesLog: '组织架构变更日志',
    promotionlist: '调动申请管理',
    recommendedtreesnapshot: '推荐树快照',
    mothercaptainchainsnapshot: '母队长链快照',
    recommendationrelationship: '推荐关系',
    rewardpunishmentlist: '顾问奖惩记录',
  },
  advisoractivity: {
    manage: '顾问活动管理',
    personalactivitylist: '顾问打卡活动列表',
    teamactivitylist: '会议培训列表',
    attendancelist: '考勤列表',
    attendancecreate: '考勤管理',
    attendanceedit: '考勤管理',
    attendanceimport: '考勤数据导入',
    attendanceloglist: '考勤操作日志',
  },
  history: {
    manage: '历史页面',
  },
  aftersales: {
    manage: '售后中心',
    serviceorderlist: '服务订单管理',
    serviceorderfinish: '完成服务订单',
    serviceorderadminassign: '服务订单派单',
    serviceorderimport: '服务订单导入',
    serviceorderoperatelog: '服务订单操作日志',
    serviceworkflowoperatelog: '服务订单操作日志',
  },
  advisorinduction: {
    manage: '顾问加入管理',
    list: '顾问加入申请列表',
    storeCandidatelist: '店铺创建申请列表',
    edit: '顾问编辑',
    detail: '顾问详情',
    import: '候选人导入',
    fteadd: 'FTE入职申请',
    fteentrycheck: 'FTE入职校验',
    blacklist: '顾问申请黑名单',
    blackimport: '顾问申请黑名单导入',
    loglist: '候选人操作日志',
    newpersonmissionloglist: '加入任务操作日志',
    newtasklist: '顾问加入任务',
  },
  organizationalstructure: {
    manage: '组织架构管理',
    teamlist: '小队列表',
    teamcreate: '创建小队',
    storelist: '店铺管理',
    storecreate: '创建店铺',
    storedetail: '店铺详情',
    storeedit: '店铺编辑',
    storeInfoChangesLog: '店铺信息变更日志',
    storeUserBindingLog: '人员店铺绑定日志',
    studiolist: '生活馆列表',
    studiocreate: '创建生活馆',
    studioedit: '编辑生活馆',
    arealist: '地区列表',
    areacreate: '创建地区',
    classroomlist: '教室列表',
    classroomcreate: '创建教室',
    classroomedit: '编辑教室',
    classroomreservationlist: '教室预约列表',
    storeCandidateOperation: '店铺加入操作日志',
    storeCandidateInfoChangeLog: '店铺加入信息变更日志',
  },
  paycenter: {
    manage: '支付中心',
    activitylist: '分期活动管理',
    // activitylist: '支付管理',
    activitycreate: '创建分期活动',
    activityedit: '编辑分期活动',
    activityitemslist: '分期活动明细管理',
    activityitemcreate: '分期支付活动明细创建',
    paymentmanagementlist: '支付单管理',
  },
  advisorbinding: {
    manage: '顾问绑定管理',
    list: '顾问绑定关系列表',
    add: '顾问绑定新增',
    edit: '顾问绑定编辑',
    againbind: '重新绑定',
  },
  binginglog: {
    manage: '绑定日志',
    list: '绑定日志',
  },
  manager: {
    manage: '负责人管理',
    list: '负责人列表',
    add: '负责人新增',
    edit: '负责人编辑',
    import: '负责人导入',
  },
  branch: {
    manage: '门店管理',
    list: '分公司列表',
    add: '分公司创建',
    edit: '分公司编辑',
  },
  ambassador: {
    manage: '大使管理',
    list: '大使申请列表',
    signcontractimport: '大使签约导入',
    edit: '大使编辑',
    blacklist: '大使黑名单',
    blackimport: '大使黑名单导入',
    loglist: '大使操作日志',
  },
  honorambassador: {
    list: '荣誉大使申请列表',
  },
  order: {
    manage: '预约单管理',
    list: '预约单总览',
    sourcelist: '预约来源管理',
    sourceadd: '预约第三方来源添加',
    detail: '预约单详情',
    import: '预约单导入',
    dashboard: '预约单统计',
    bannerlist: 'banner管理',
  },
  consultingservicecenter: {
    manage: '顾问福利中心',
    welfarelist: '员工券领取管理',
    partlist: '示范机配件管理',
    import: '配件库存导入',
    suitlist: '示范机分发管理',
    resoldqualification: '转售资格管理',
    quotaimport: '导入转售资格',
    resalequotalist: '示范机转售资格变更日志',
  },
  staticresourcescenter: {
    manage: 'banner管理',
    bannerlist: 'banner管理',
  },
  finacemonth: {
    manage: '财务月管理',
    list: '财务月列表',
    finaceweeklist: '财务周列表',
    advisorsnapshot: '财务月底在职顾问快照',
    operationlog: '财务月操作日志',
  },
  excel: {
    manage: 'excel 管理',
    upload: '上传excel',
  },
  home: {
    page: '< 返回首页',
  },
};



// WEBPACK FOOTER //
// ./src/assets/i18n/lang/zh.js